<template>

    <div class="field" :style="{'min-width': min_width + 'px'}">
        <label class="field-label" v-if="title">
            <AppIcon v-if="icon" :name="icon" class="field-icon"/>
            <span>{{ title }}</span>
        </label>
        <input :type="input_type" :placeholder="placeholder" v-model="value" class="field-input" onfocus="this.select()">
    </div>

</template>


<script>

import AppIcon from './AppIcon.vue';

export default {
    name: 'InputUI',

    components: {
        AppIcon
    },

    props: {
        title: {
            type: String,
        },
        icon: {
            type: String,
        },
        input_type: {
            type: String,
            default: 'text'
        },
        placeholder:{
            type: String
        },
        min_width: {
            type: Number,
            default: 300
        },
        myval:{
            type: String
        }
    },

    data() {
        return {
            value: this.myval,
        }
    },

    watch: {
        value(val) {
            this.$emit('myData', val)
        },
        myval(val) {
            this.value = val
        }
    }
}

</script>


<style scoped>

.field{
    display: flex;
    flex-direction: column;
    gap: 6px;

    max-width: 100%;

    margin-right: 10px;
}

.field-label{
    display: inline-flex;
    align-items: center;
    gap: 6px;

    font-size: 13px;
    font-weight: 500;
    color: var(--muted-foreground);
}

.field-icon{
    width: 15px;
    height: 15px;
}

.field-input{
    width: 100%;
    height: 38px;
    padding: 0 12px;

    font-family: inherit;
    font-size: 14px;
    color: var(--foreground);

    background: var(--card);
    border: 1px solid var(--border);
    border-radius: 8px;
    outline: none;

    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.field-input::placeholder{
    color: var(--placeholder);
}

.field-input:hover{
    border-color: var(--border-hover);
}

.field-input:focus{
    border-color: var(--input-border-focus);
    box-shadow: 0 0 0 3px var(--ring);
}

</style>
